import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  getBusiness,
  getBusinessSummary,
  patchBusiness,
  updateBusinessSummary,
} from '~/services/BusinessTraveller/BusinessTravellerService';

export const businessDetailsQueryKeys = {
  all: ['business-details'],
  detail: (businessId: string) => [...businessDetailsQueryKeys.all, 'detail', businessId],
  summary: (businessId: string) => [...businessDetailsQueryKeys.all, 'summary', businessId],
};

export function useGetBusiness(businessId: string) {
  return useQuery({
    queryKey: businessDetailsQueryKeys.detail(businessId),
    queryFn: () => getBusiness(businessId),
    enabled: !!businessId,
  });
}

export function useUpdateBusiness(businessId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (business: App.Business) => patchBusiness(businessId, business),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: businessDetailsQueryKeys.detail(businessId) });
    },
  });
}

export function useGetBusinessSummary(businessId: string) {
  return useQuery({
    queryKey: businessDetailsQueryKeys.summary(businessId),
    queryFn: async () => {
      const response = await getBusinessSummary(businessId);
      return response.result.businessSummary || '';
    },
    enabled: !!businessId,
  });
}

export function useUpdateBusinessSummary(businessId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (businessSummary: string) => updateBusinessSummary(businessId, { businessSummary }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: businessDetailsQueryKeys.summary(businessId) });
    },
  });
}
